/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SendMailVaccineAliases {
  BUTTON_SEND_MAIL = 'button-send-mail',
  FIELD_LIST_DROPDOWN_SEND_MAIL = 'field-list-dropdown-send-mail',
  FIELD_SEND_MAIL = 'field-send-mail',
  FORM_DROPDOWN_SEND_MAIL = 'form-dropdown-send-mail',
  INPUT_0 = 'input-0',
  LAYOUT_5 = 'layout-5',
  LOADER_SEND_MAIL = 'loader-send-mail',
  PANEL_0 = 'panel-0',
  PANEL_2 = 'panel-2',
  PANEL_LOADER_SEND_MAIL = 'panel-loader-send-mail',
  SEND_MAIL_FIELD_EMAIL_LIST = 'send-mail-field-email-list',
  SEND_MAIL_FIELD_NOTES = 'send-mail-field-notes',
  SEND_MAIL_PANEL = 'send-mail-panel',
  SEND_MAIL_VACCINE = 'send-mail-vaccine',
  TEXT_AREA_0 = 'text-area-0',
}
export { SendMailVaccineAliases };
